// src/pages/legal/Terms.js
import React from 'react';
import { Container, Typography, Box, Breadcrumbs, Link, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const Terms = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 4 }}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          <Link component={RouterLink} to="/dashboard" underline="hover" color="inherit">
            Dashboard
          </Link>
          <Typography color="text.primary">Terms of Service</Typography>
        </Breadcrumbs>
      </Box>

      <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight={600}>
          Terms of Service
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" gutterBottom fontWeight={600}>
            1. Introduction
          </Typography>
          <Typography paragraph>
            Welcome to AI Widget Studio. These Terms of Service ("Terms") govern your access to and use of our website, 
            products, and services ("Services"). By accessing or using our Services, you agree to be bound by these Terms.
          </Typography>
          <Typography paragraph>
            Please read these Terms carefully. If you do not agree with these Terms, you may not access or use our Services.
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" gutterBottom fontWeight={600}>
            2. Using Our Services
          </Typography>
          <Typography paragraph>
            You must follow any policies made available to you within the Services. You may use our Services only as 
            permitted by law. We may suspend or stop providing our Services to you if you do not comply with our terms or 
            policies or if we are investigating suspected misconduct.
          </Typography>
          <Typography paragraph>
            Using our Services does not give you ownership of any intellectual property rights in our Services or the 
            content you access. You may not use content from our Services unless you obtain permission from its owner or 
            are otherwise permitted by law.
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" gutterBottom fontWeight={600}>
            3. Privacy and Copyright Protection
          </Typography>
          <Typography paragraph>
            Our Privacy Policy explains how we treat your personal data and protect your privacy when you use our Services. 
            By using our Services, you agree that we can use such data in accordance with our privacy policies.
          </Typography>
          <Typography paragraph>
            We respond to notices of alleged copyright infringement and terminate accounts of repeat infringers according 
            to the process set out in the U.S. Digital Millennium Copyright Act.
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" gutterBottom fontWeight={600}>
            4. Your Content in Our Services
          </Typography>
          <Typography paragraph>
            Some of our Services allow you to upload, submit, store, send or receive content. You retain ownership of any 
            intellectual property rights that you hold in that content. When you upload, submit, store, send or receive 
            content to or through our Services, you give us a worldwide license to use, host, store, reproduce, modify, 
            create derivative works, communicate, publish, publicly perform, publicly display and distribute such content.
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" gutterBottom fontWeight={600}>
            5. Modifying and Terminating our Services
          </Typography>
          <Typography paragraph>
            We are constantly changing and improving our Services. We may add or remove functionalities or features, and 
            we may suspend or stop a Service altogether.
          </Typography>
          <Typography paragraph>
            You can stop using our Services at any time. We may also stop providing Services to you, or add or create new 
            limits to our Services at any time.
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" gutterBottom fontWeight={600}>
            6. Liability for our Services
          </Typography>
          <Typography paragraph>
            When permitted by law, AI Widget Studio, and its suppliers and distributors, will not be responsible for lost 
            profits, revenues, or data, financial losses or indirect, special, consequential, exemplary, or punitive damages.
          </Typography>
          <Typography paragraph>
            To the extent permitted by law, the total liability of AI Widget Studio, and its suppliers and distributors, for 
            any claims under these terms, including for any implied warranties, is limited to the amount you paid us to use 
            the Services.
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" gutterBottom fontWeight={600}>
            7. About these Terms
          </Typography>
          <Typography paragraph>
            We may modify these terms or any additional terms that apply to a Service to, for example, reflect changes to 
            the law or changes to our Services. You should look at the terms regularly. We'll post notice of modifications 
            to these terms on this page.
          </Typography>
          <Typography paragraph>
            If you do not agree to the modified terms for a Service, you should discontinue your use of that Service.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default Terms;